import { defSimpleUnit, defAlias, defBaseUnit } from '../registry';

export const timeUnits = [
  defBaseUnit('second'),

  defSimpleUnit('millisecond', 'second', 0.001),
  defSimpleUnit('microsecond', 'second', 0.000001),
  defSimpleUnit('nanosecond', 'second', 0.000000001),

  defSimpleUnit('minute', 'second', 60),
  defSimpleUnit('hour', 'second', 3600),
  defSimpleUnit('day', 'second', 86400),
  defSimpleUnit('week', 'second', 604800),
  defSimpleUnit('fortnight', 'second', 1209600),

  defSimpleUnit('planck_time', 'second', 5.39116e-44),
];

defAlias('s', 'second');
defAlias('instance_hour', 'hour');
defAlias('streaming_hour', 'hour');
defAlias('streaming_minute', 'minute');
defAlias('days', 'day');
